import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LensBlurIcon(props: IconProps) {
    return <Icon {...props} iconKey={"lens_blur"}/>
}
